import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faBell, faBug, faCalendar, faCarSide, faCheck, faClipboardList, faCloudRain, faComment,
  faExclamationTriangle, faFlag, faKey, faLeaf, faMapMarkerAlt, faSeedling, faStickyNote,
  faSun, faTint, faTractor, faTruck, faWarehouse, faWrench,
} from '@fortawesome/free-solid-svg-icons';

/**
 * Curated icon catalog for farm note types. The note-type manager exposes these as a
 * dropdown so users can't pick an icon name we don't ship. To add more, import the icon
 * above and append a row here.
 */
export interface FarmIconChoice {
  name: string;            // stored on FarmNoteType.icon
  label: string;           // human label in the picker
  icon: IconDefinition;
}

export const FARM_NOTE_ICONS: FarmIconChoice[] = ([
  { name: 'sticky-note',          label: 'Note',        icon: faStickyNote },
  { name: 'comment',              label: 'Comment',     icon: faComment },
  { name: 'key',                  label: 'Access',      icon: faKey },
  { name: 'car-side',             label: 'Travel',      icon: faCarSide },
  { name: 'map-marker-alt',       label: 'Location',    icon: faMapMarkerAlt },
  { name: 'tint',                 label: 'Irrigation',  icon: faTint },
  { name: 'tractor',              label: 'Equipment',   icon: faTractor },
  { name: 'wrench',               label: 'Maintenance', icon: faWrench },
  { name: 'seedling',             label: 'Crop',        icon: faSeedling },
  { name: 'leaf',                 label: 'Orchard',     icon: faLeaf },
  { name: 'bug',                  label: 'Pests',       icon: faBug },
  { name: 'sun',                  label: 'Weather',     icon: faSun },
  { name: 'cloud-rain',           label: 'Rain',        icon: faCloudRain },
  { name: 'truck',                label: 'Hauling',     icon: faTruck },
  { name: 'warehouse',            label: 'Storage',     icon: faWarehouse },
  { name: 'clipboard-list',       label: 'Compliance',  icon: faClipboardList },
  { name: 'calendar',             label: 'Schedule',    icon: faCalendar },
  { name: 'bell',                 label: 'Reminder',    icon: faBell },
  { name: 'flag',                 label: 'Flag',        icon: faFlag },
  { name: 'exclamation-triangle', label: 'Issue',       icon: faExclamationTriangle },
  { name: 'check',                label: 'Done',        icon: faCheck },
] as FarmIconChoice[]).sort((a, b) => a.label.localeCompare(b.label));

const byName: { [key: string]: IconDefinition } = FARM_NOTE_ICONS.reduce(
  (acc, c) => { acc[c.name] = c.icon; return acc; },
  {} as { [key: string]: IconDefinition }
);

export function lookupFarmNoteIcon(name: string): IconDefinition {
  return byName[name] || faStickyNote;
}
